module.exports = require("@bigcommerce/memoize");